<div class="white-box p-4 border-radius mt-2">
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
	<div class="text-danger" *ngIf="invalidDateRange"><b>{{'g.start_lg_end' | translate}}</b></div>
</div>
